module.exports = __webpack_public_path__ + "img/4.a82f9fea.jpeg";